import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import './CarTile.css';/* empty css             */
const CarTileTable = ({ items, className }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-car-tile-table", className), children: items.map(({ id, icon, text }) => /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-car-tile-table__item"), children: [
    /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "light", className: classnames("perxis-auto-car-tile-table__item-icon"), children: /* @__PURE__ */ jsx(Icon, { name: icon }) }),
    /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "dark-light", className: classnames("perxis-auto-car-tile-table__item-text"), children: text })
  ] }, id)) });
};
export {
  CarTileTable as default
};
//# sourceMappingURL=CarTileTable.js.map
